import React from "react";
import AffiliateBase from "../components/Affiliate/AffiliateBase";
import AffiliateCommission from "../components/Affiliate/AffiliateCommission";
import { useSelector } from "react-redux";
import { ApplicationState } from "../store";

const Affiliate = () => {
	const prefixState = useSelector((state: ApplicationState) => state.prefix)

	return (
		<>

			{prefixState?.info?.affiliateLevel ? <AffiliateCommission /> : <AffiliateBase />}
			{/* {true ? <AffiliateBase /> : <AffiliateCommission />} */}
			{/* {user?.phone === "1111111112" ? <AffiliateCommission /> : <AffiliateBase />} */}
		</>
	)
}

export default Affiliate;